


document.addEventListener("DOMContentLoaded", () => {
  // Check if .tabs-with-content exists
  const tabSections = document.querySelectorAll(".tabs-with-content");

  // Exit if no tab sections found
  if (!tabSections.length) return;

  // Loop through each section
  tabSections.forEach(section => {
    // Find all .row.group-box elements inside this section
    const groupBoxes = section.querySelectorAll(".row.group-box");

    // Skip this section if it has no group-box
    if (!groupBoxes.length) return;

    // Loop through each group-box
    groupBoxes.forEach(groupBox => {
      // Find all .col-four inside this specific group-box
      const cols = groupBox.querySelectorAll(".col-four");
      const count = cols.length;

      // Skip if no .col-four found
      if (count === 0) return;

      // Clean any previously added count-based classes
      groupBox.classList.remove("one-col", "two-col", "three-col", "four-col");

      // Add the appropriate class depending on the number of columns
      if (count === 1) {
        groupBox.classList.add("one-col");
      } else if (count === 2) {
        groupBox.classList.add("two-col");
      } else if (count === 3) {
        groupBox.classList.add("three-col");
      } else {
        groupBox.classList.add("four-col");
      }
    });
  });
});
document.addEventListener('animationstart', function (e) {
  const el = e.target;

  // Only for .group-box wow fadeInUp
  if (el.classList.contains('group-box') &&  el.closest('.tabs-with-content') && el.classList.contains('wow') && el.classList.contains('fadeInUp')) {
    // Add marker class
    el.classList.add('wow-played');
  }
}, { passive: true });



(function ($) {
  $(document).ready(function () {
    $(".tabs-with-content").each(function () {
      const $section = $(this);
      const $tabs = $section.find(".tabs-items ul li");
      const $tabContents = $section.find(".tab-content");
      const $mobileVisible = $section.find(".tabs-items .mobile-visible");

      // If only one tab content, add 'no-tab' class
      if ($tabContents.length > 0 && $tabContents.length < 2) {
        $section.addClass("no-tab");
      }

      // Set first tab text to mobile-visible
      const firstText = $tabs.first().find("span").text();
      $mobileVisible.text(firstText);

      // Hide all tab content except the first
      $tabContents.hide().first().show();
      $tabs.first().addClass("active");

      // Mobile toggle for dropdown
      $mobileVisible.on("click", function () {
        $(this).siblings("ul").slideToggle();
        $(this).toggleClass("active");
      });

      // On tab click
      $tabs.find("span").on("click", function () {
        const $li = $(this).parent();
        const tabId = $li.data("tab");
        const tabText = $(this).text();

        // Update active tab
        $tabs.removeClass("active");
        $li.addClass("active");

        // Update mobile-visible text
        $mobileVisible.text(tabText);

        // Show matching tab content
        $tabContents.hide();
        $section.find('.tab-content[data-tab="' + tabId + '"]').show();
        

        // Collapse mobile menu on smaller screens
        if ($(window).width() < 992) {
          $li.closest("ul").slideUp();
          $mobileVisible.removeClass("active");
        }
      });
    });

    // Reset state on resize
    $(window).on("resize", function () {
      if ($(window).width() >= 992) {
        $(".tabs-with-content .tabs-items .mobile-visible").removeClass("active");
        $(".tabs-with-content .tabs-items ul").removeAttr("style");
      }
    });

    // Add animation class at the end of document ready for best compatibility
    $(".tabs-with-content .tab-wrapper").addClass("active");
  });
})(jQuery);

